import { Component, ElementRef } from "@angular/core";
import { SingService } from "../service/sing.service";
import { SingInForm } from "./class/sing-in-form";
import { Action } from "./services/action.service";
import { Broadcaster } from "../service/Broadcaster";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Menu } from "./class/menu";
import { Rooftop } from "./class/rooftop";
import { Client } from "./class/client";
import { Rights } from "../class/rights";
import { SingIn } from "./class/sing-in";
import { Error } from "../class/broadcaster/app/error";
import { responseClientList } from "../class/http/res/response-client-list";
import { responseGetUser } from "../class/http/res/response-get-user";
import { updateRooftops } from "../class/broadcaster/update-rooftops";
import { getSelectedRofftop } from "../class/broadcaster/app/get-selected-rofftop";
import { onInitGraph } from "../class/broadcaster/app/onInit-graph";
import { requestXLSBudget } from "../class/http/req/request-xls-budget";
import { saveFileCSV } from "../service/file-download-helper";
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
@Component({
    selector: "app-root",
    templateUrl: "html/app.component.html",
    styleUrls: ["css/app.component.css", "css/sing.css"],
    providers: [SingService, Broadcaster, Action],
})
export class AppComponent {
    title = "CLC One Vision";
    menu: Array<Menu> = [
        new Menu("/rtb", "Planner", "/rtb"),
        new Menu("/budget", "Budget", "/budget"),
        new Menu("/dashboard", "Analytics", "/dashboard")
    ];
    rooftops: Array<Rooftop> = [];
    clients: Array<Client> = [];
    Error: Error = new Error("", []);
    user: SingInForm = new SingInForm();
    Auth: boolean = false;
    showSingIn: boolean = false;
    ErrorAuth: boolean = false;
    rights: Rights;
    blockSwitchViewGraph: boolean = false;
    switchGraph: boolean = false;
    switchViewGraph: boolean = true;
    constructor(

        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private route: ActivatedRoute,
        private Actions: Action,
    ) { }
    ngOnInit() {
      
        $("[data-toggle='tooltip']").tooltip({ animation: true });

        if (this.Actions.getAuthData().loggedIn !== "") {
            if (!this.Actions.getAuthData().identity) {
                this.Actions.LogOut();
                return;
            }
            this.Actions.updateCookie();
            this.Actions.onInit();
            this.rights = this.Actions.getAuthData().identity.rights;
            this.menu = (this.rights.canViewBudget === 0) ? [] : this.menu;
            this.Actions.sub = this.route.queryParams.subscribe(params => {

                for (let i = 0; i < this.menu.length; i++) {
                    this.menu[i].path = `${this.menu[i].defaultPath}?id=${params["id"] || 0}`;
                }
                this.Actions.getParams = params;
            });
            this.Actions.getClients().subscribe((res: responseClientList) => {


                this.Auth = true;
                this.showSingIn = false;
                this.clients = res.list;
                let clientId:number = (window.localStorage.getItem("clientId")) ? Number(window.localStorage.getItem("clientId")) : this.clients[0].id;
                if (clientId !== Number(this.Actions.getParams["id"]))
                {
                    
                    window.location.href = `${window.location.pathname}?id=${clientId}`;
                }
                for (let i = 0; i < this.clients.length; i++) {
                    this.clients[i].class = (clientId === this.clients[i].id) ? "m--active" : ""
                }
                this.Actions.UpdateClients = true;
                this.initEventListeners();

            });

        } else {
            this.Auth = false;
            this.showSingIn = true;
        }
      
        this.broadcaster.on<any>("updateRooftops").subscribe((data:updateRooftops) => {
            if (data.rooftops.length > 1) {
                let result: any = this.Actions.generalService.findGetParamRooftop(data.rooftops, this.Actions.getParams["rooftop"], this.Actions.tableData.settings);
                this.rooftops = result.rooftops;
                this.broadcaster.broadcast("getSelectedRofftop", new getSelectedRofftop(this.rooftops));
            }
            else {
                this.rooftops = (<Array<Rooftop>>data.rooftops);
            }

            this.Actions.UpdateRofftops = true;

        });
        this.broadcaster.on<string>("AuthError").subscribe((message:String) => {

           if (message === "401" || message === "403") {
                this.Auth = false;
                this.Actions.AuthError();
            }
            if (message === "403") {
                this.ErrorAuth = true;
            }
        });

        this.broadcaster.on<any>("InfoError").subscribe((message: Error) => {

            this.Error = message;
            this.elRef.nativeElement.querySelector(".info-error-mask").style.display = "block";
            this.elRef.nativeElement.querySelector(".info-error").style.display = "block";
        });



    }
     DownloadXLS() {
        this.broadcaster.broadcast("showExportCSV", null);

    }
    changeClient(event) {
      
        let index = this.clients.findIndex(element => element.name === event.target.value);
        window.localStorage.setItem("clientId", String(this.clients[index].id));
        window.location.href = `${window.location.pathname}?id=${this.clients[index].id}`
    }
    changeRooftop(event) {
        let index = this.rooftops.findIndex(element => element.title === event.target.value);
        this.broadcaster.broadcast("selectRofftop", this.rooftops[index].id);
    }

    initEventListeners() {
        if (window.localStorage.getItem("graphStatus") && Number(window.localStorage.getItem("graphStatus")) === 0) {
            this.switchGraph = true;
            this.blockSwitchViewGraph = (this.switchGraph) ? true : false;
        }
        if (window.localStorage.getItem("viewCompactStatus") && !this.blockSwitchViewGraph) {
            this.switchViewGraph = (Number(window.localStorage.getItem("viewCompactStatus")) === 0 ? true : false);
        }
    }

    onChangeGraphView(value: boolean, change: boolean) {
        if (this.blockSwitchViewGraph && !change) return;
        this.switchViewGraph = (change) ? value : (this.switchViewGraph) ? false : true;
        this.broadcaster.broadcast("onInitGraph", new onInitGraph("onChangeGraphView",this.switchViewGraph,change));

    }
    ToggleGraphs(value: boolean, change: boolean) {
        this.switchGraph = (change) ? value : (this.switchGraph) ? false : true;
        this.blockSwitchViewGraph = (this.switchGraph) ? true : false;
        this.broadcaster.broadcast("onInitGraph", new onInitGraph("onToggleGraphs",this.switchGraph,change));
        this.switchViewGraph = (this.blockSwitchViewGraph) ? false : this.switchViewGraph;

    }
    trackByIndex(index, item) {
        return index;
    }
    ngOnDestroy() {
        this.Actions.sub.unsubscribe();
    }

    LogOut(event: any): void {
        event.preventDefault();
        this.Actions.LogOut();
    }
    onSubmit(singIn: NgForm) {
        this.Actions.IsEmail(singIn.value.login)
            ? (this.user.ValidEmail = true)
            : (this.user.ValidEmail = false);

        this.ErrorAuth = false;
        let singIb: SingIn = new SingIn(singIn.value.login, singIn.value.password, (this.user.remember) ? 1 : 0);
        this.Actions.singIn(singIb).subscribe((data: responseGetUser) => {
            this.ErrorAuth = false;
            this.Actions.getClients().subscribe((res: responseClientList) => {
              
               this.showSingIn = false;
                this.Actions.setDataUser(data, res.list);
            });
        });
    }
    callOnLastIteration() {
        if (this.Actions.UpdateRofftops) {
            if (this.rooftops.length > 1) {
                let index = this.rooftops.findIndex(element => element.class === "m--active");
                this.elRef.nativeElement.querySelector(".rooftops-in-head select").value = this.rooftops[index].title;
            }
            this.Actions.UpdateRofftops = false;
        }
    }
    callOnLastIterationClients() {
        if (this.Actions.UpdateClients) {
            if (this.clients.length > 1) {
                let index = this.clients.findIndex(element => element.class === "m--active");
                this.elRef.nativeElement.querySelector(".clients-list select").value = this.clients[index].name;
            }
            this.Actions.UpdateClients = false;

        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts